import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useIntersectionObserver } from "web/react/hooks/use-intersection-observer/use-intersection-observer";
import classnames from "classnames";
import styles from "./lazy-load-image.css";

export const placeholderImage =
    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

export default function LazyLoadImage({ src, alt, className, role }) {
    let options = {
        threshold: 0,
        rootMargin: "0px",
        once: true,
    };
    const imageRef = useRef();
    const [isVisible] = useIntersectionObserver(options, imageRef);

    return (
        <img
            className={classnames(className, styles.lazyLoadImage, {
                [styles.loaded]: isVisible,
            })}
            ref={imageRef}
            src={isVisible ? src : placeholderImage}
            alt={alt}
            role={role}
        />
    );
}

LazyLoadImage.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
    role: PropTypes.string,
};
